import label from "@/lang/StaticLabels.js";

// PACNT Router  - حسابداری  -----------------------------------------------
let routeItems = {
  path: "PACNT",
  name: "PACNT",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  // با کلیک روی ماژول، داشبورد همان ماژول پیش‌فرض باز می‌شود
  redirect: { name: "PACNTDashboard" },
  children: [
    {
      path: "dashboard",
      name: "PACNTDashboard",
      meta: {
        label: label.page.dashboard + " " + label.modules.pacnt,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pacnt/Dashboard"),
    },
    {
      path: "accountConfig",
      name: "PACNTAccountConfig",
      meta: {
        label: label.page.accountConfig,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pacnt/base/accountConfig"),
    },
    {
      path: "accountControlConfig",
      name: "PACNTAccountControlConfig",
      meta: {
        label: label.page.accountControlConfig,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pacnt/base/accountControlConfig"),
    },
    {
      path: "accountInfo",
      name: "PACNTAccountInfo",
      meta: {
        label: label.page.accountInfo,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pacnt/base/accountInfo"),
    },
    {
      path: "voucherNoteType",
      name: "PACNTVoucherNoteType",
      meta: {
        label: label.page.voucherNoteType,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pacnt/base/voucherNoteType"),
    },
    {
      path: "defaultVoucherDescription",
      name: "PACNTDefaultVoucherDescription",
      meta: {
        label: label.page.defaultVoucherDescription,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pacnt/base/defaultVoucherDescription"),
    },
    {
      path: "financialRatio",
      name: "PACNTFinancialRatio",
      meta: {
        label: label.page.financialRatioSetting,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pacnt/base/financialRatio"),
    },

    {
      path: "personCredit",
      name: "PACNTPersonCredit",
      meta: {
        label: label.page.personCredit,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pacnt/base/personCredit"),
    },
    {
      path: "voucher",
      name: "PACNTVoucher",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "voucher/list",
      children: [
        {
          path: "list",
          name: "PACNTVoucherList",
          component: () => import("@/views/modules/pacnt/operation/voucher"),
          meta: {
            label: label.page.voucher,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PACNTAddVoucher",
          // AddResponsive بین نسخهٔ دسکتاپ (Add) و نسخهٔ موبایل (AddMobile) سوییچ می‌کند
          component: () =>
            import("@/views/modules/pacnt/operation/voucher/AddResponsive"),
          meta: {
            label: label.page.addVoucher,
            requiresAuth: true,
            mode: "add",
          },
        },
        {
          path: "edit",
          name: "PACNTEditVoucher",
          component: () =>
            import("@/views/modules/pacnt/operation/voucher/AddResponsive"),
          meta: {
            label: label.page.editVoucher,
            requiresAuth: true,
            mode: "edit",
          },
        },
        {
          path: "add-new",
          name: "PACNTAddVoucherNew",
          component: () =>
            import("@/views/modules/pacnt/operation/voucher/Add-1"),
          meta: {
            label: label.page.addVoucherNew,
            requiresAuth: true,
            mode: "add",
          },
        },
        {
          path: "edit/new",
          name: "PACNTEditVoucherNew",
          component: () =>
            import("@/views/modules/pacnt/operation/voucher/Add-1"),
          meta: {
            label: label.page.editVoucher,
            requiresAuth: true,
            mode: "edit",
          },
        },
        // {
        //   path: "edit/:id",
        //   name: "PACNTEditVoucher",
        //   component: () =>
        //     import("@/views/modules/pacnt/operation/voucher/Add"),
        //   meta: {
        //     label: label.page.editVoucher,
        //     requiresAuth: true,
        //   },
        // },
      ],
    },
    {
      path: "voucherSort",
      name: "PACNTVoucherSort",
      meta: {
        label: label.page.voucherSort,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pacnt/operation/voucherCartable/Sort"),
    },
    {
      path: "voucherConfirm",
      name: "PACNTVoucherConfirm",
      meta: {
        label: label.page.voucherConfirm,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pacnt/operation/voucherCartable/confirm/index"),
    },
    {
      path: "voucherReview",
      name: "PACNTVoucherReview",
      meta: {
        label: label.page.voucherReview,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pacnt/operation/voucherReview"),
    },
    {
      path: "voucherMerge",
      name: "PACNTVoucherMerge",
      meta: {
        label: label.page.voucherMerge,
        requiresAuth: true,
      },
      component: () =>
        import(
          "@/views/modules/pacnt/operation/voucherCartable/MergeResponsive"
        ),
    },
    {
      path: "archiveVoucher",
      name: "PACNTArchiveVoucher",
      meta: {
        label: label.page.archiveVoucher,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pacnt/operation/voucherCartable/Archive"),
    },
    {
      path: "debtorOrCreditorDeclaration",
      name: "PACNTDebtorOrCreditorDeclaration",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "debtorOrCreditorDeclaration/list",
      children: [
        {
          path: "list",
          name: "PACNTDebtorOrCreditorDeclarationList",
          component: () =>
            import(
              "@/views/modules/pacnt/operation/debtorOrCreditorDeclaration"
            ),
          meta: {
            label: label.page.debtorOrCreditorDeclaration,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PACNTAddDebtorOrCreditorDeclaration",
          component: () =>
            import(
              "@/views/modules/pacnt/operation/debtorOrCreditorDeclaration/Add"
            ),
          meta: {
            label: label.page.addDebtorOrCreditorDeclaration,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PACNTEditDebtorOrCreditorDeclaration",
          component: () =>
            import(
              "@/views/modules/pacnt/operation/debtorOrCreditorDeclaration/Add"
            ),
          meta: {
            label: label.page.editDebtorOrCreditorDeclaration,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "groupChangeVoucherArticles",
      name: "PACNTGroupChangeVoucherArticles",
      meta: {
        label: label.page.groupChangeVoucherArticles,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pacnt/operation/groupChangeVoucherArticles"),
    },
    {
      path: "voucherVerification",
      name: "PACNTVoucherVerification",
      meta: {
        label: label.page.voucherVerification,
        requiresAuth: true,
      },
      component: () =>
        import(
          "@/views/modules/pacnt/operation/voucherCartable/Verification.vue"
        ),
    },
    {
      path: "closeAccounts",
      name: "PACNTCloseAccounts",
      meta: {
        label: label.page.closeAccounts,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pacnt/operation/closeAccounts/index.vue"),
    },
    {
      path: "managementCartable",
      name: "PACNTManagementCartable",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "managementCartable/Voucher",
      children: [
        {
          path: "Voucher",
          name: "PACNTManagementCartableVoucher",
          component: () =>
            import(
              "@/views/modules/pacnt/operation/managementCartable/Voucher"
            ),
          meta: {
            label: label.page.managementCartableVoucher,
            requiresAuth: true,
          },
        },
      ],
    },
    // Reports -----------------------------------------------
    {
      path: "reports",
      name: "PACNTReports",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "reports",
      children: [
        {
          path: "journalReport",
          name: "PACNTJournalReport",
          component: () =>
            import("@/views/modules/pacnt/reports/journalReport/index.vue"),
          meta: {
            label: label.page.journalReport,
            requiresAuth: true,
          },
        },
        {
          path: "accountOperationDetailReport/:accountInfoId?",
          name: "PACNTAccountOperationDetailReport",
          component: () =>
            import(
              "@/views/modules/pacnt/reports/accountOperationDetail/index.vue"
            ),
          meta: {
            label: label.page.accountOperationDetailReport,
            requiresAuth: true,
          },
        },
        {
          path: "circulationOfAccounts",
          name: "PACNTCirculationOfAccounts",
          component: () =>
            import(
              "@/views/modules/pacnt/reports/circulationOfAccounts/index.vue"
            ),
          meta: {
            label: label.page.circulationOfAccounts,
            requiresAuth: true,
          },
        },
        {
          path: "accountOffice",
          name: "PACNTAccountOffice",
          component: () =>
            import(
              "@/views/modules/pacnt/reports/accountOfficeReport/index.vue"
            ),
          meta: {
            label: label.page.accountOffice,
            requiresAuth: true,
          },
        },
        {
          path: "individualOperationDetailReport/:personId?",
          name: "PACNTIndividualOperationDetailReport",
          component: () =>
            import(
              "@/views/modules/pacnt/reports/individualOperationDetailReport/index.vue"
            ),
          meta: {
            label: label.page.individualOperationDetailReport,
            requiresAuth: true,
          },
        },
        {
          path: "trialBalance4ColumnsReport",
          name: "PACNTTrialBalance4ColumnsReport",
          component: () =>
            import(
              "@/views/modules/pacnt/reports/trialBalance4ColumnsReport/index.vue"
            ),
          meta: {
            label: label.page.trialBalance4ColumnsReport,
            requiresAuth: true,
          },
        },
        {
          path: "trialBalance6ColumnsReport",
          name: "PACNTTrialBalance6ColumnsReport",
          component: () =>
            import(
              "@/views/modules/pacnt/reports/trialBalance6ColumnsReport/index.vue"
            ),
          meta: {
            label: label.page.trialBalance6ColumnsReport,
            requiresAuth: true,
          },
        },
        {
          path: "trialBalance8ColumnsReport",
          name: "PACNTTrialBalance8ColumnsReport",
          component: () =>
            import(
              "@/views/modules/pacnt/reports/trialBalance8ColumnsReport/index.vue"
            ),
          meta: {
            label: label.page.trialBalance8ColumnsReport,
            requiresAuth: true,
          },
        },
        {
          path: "accountCurrencyMonitoringReport",
          name: "PACNTAccountCurrencyMonitoringReport",
          component: () =>
            import(
              "@/views/modules/pacnt/reports/accountCurrencyMonitoringReport/index.vue"
            ),
          meta: {
            label: label.page.accountCurrencyMonitoringReport,
            requiresAuth: true,
          },
        },
        {
          path: "accountCurrencyTrialBalanceReport",
          name: "PACNTAccountCurrencyTrialBalanceReport",
          component: () =>
            import(
              "@/views/modules/pacnt/reports/accountCurrencyTrialBalanceReport/index.vue"
            ),
          meta: {
            label: label.page.accountCurrencyTrialBalanceReport,
            requiresAuth: true,
          },
        },
        {
          path: "acountsWithPersonReport",
          name: "PACNTAccountWithPersonReport",
          component: () =>
            import(
              "@/views/modules/pacnt/reports/acountsWithPersonReport/index.vue"
            ),
          meta: {
            label: label.page.acountsWithPersonReport,
            requiresAuth: true,
          },
        },
        {
          path: "monthlyAccountingVoucherReport",
          name: "PACNTMonthlyAccountingVoucherReport",
          component: () =>
            import(
              "@/views/modules/pacnt/reports/monthlyAccountingVoucherReport/index.vue"
            ),
          meta: {
            label: label.page.monthlyAccountingVoucherReport,
            requiresAuth: true,
          },
        },
        {
          path: "floatAccountOperationDetail",
          name: "PACNTFloatAccountOperationDetail",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "levelOne",
              name: "PACNTFloatAccountOperationDetailLevelOne",
              component: () =>
                import(
                  "@/views/modules/pacnt/reports/floatAccountOperationDetail/levelOne"
                ),
              meta: {
                label:
                  label.menu.operationDetail + " " + label.menu.floatAccountOne,
                requiresAuth: true,
              },
            },
            {
              path: "levelTwo",
              name: "PACNTFloatAccountOperationDetailLevelTwo",
              component: () =>
                import(
                  "@/views/modules/pacnt/reports/floatAccountOperationDetail/levelTwo"
                ),
              meta: {
                label:
                  label.menu.operationDetail + " " + label.menu.floatAccountTwo,
                requiresAuth: true,
              },
            },
            {
              path: "levelThree",
              name: "PACNTFloatAccountOperationDetailLevelThree",
              component: () =>
                import(
                  "@/views/modules/pacnt/reports/floatAccountOperationDetail/levelThree"
                ),
              meta: {
                label:
                  label.menu.operationDetail +
                  " " +
                  label.menu.floatAccountThree,
                requiresAuth: true,
              },
            },
            {
              path: "levelFour",
              name: "PACNTFloatAccountOperationDetailLevelFour",
              component: () =>
                import(
                  "@/views/modules/pacnt/reports/floatAccountOperationDetail/levelFour"
                ),
              meta: {
                label:
                  label.menu.operationDetail +
                  " " +
                  label.menu.floatAccountFour,
                requiresAuth: true,
              },
            },
            {
              path: "levelFive",
              name: "PACNTFloatAccountOperationDetailLevelFive",
              component: () =>
                import(
                  "@/views/modules/pacnt/reports/floatAccountOperationDetail/levelFive"
                ),
              meta: {
                label:
                  label.menu.operationDetail +
                  " " +
                  label.menu.floatAccountFive,
                requiresAuth: true,
              },
            },
            {
              path: "text",
              name: "PACNTFloatAccountTextOperationDetail",
              component: () =>
                import(
                  "@/views/modules/pacnt/reports/floatAccountOperationDetail/text"
                ),
              meta: {
                label:
                  label.menu.operationDetail +
                  " " +
                  label.menu.floatAccountText,
                requiresAuth: true,
              },
            },
          ],
        },
        {
          path: "accountWithFloatAccount",
          name: "PACNTAccountWithFloatAccount",
          component: () =>
            import(
              "@/views/modules/pacnt/reports/accountWithFloatAccount/levelOne"
            ),
          meta: {
            label: label.menu.account + "-" + label.menu.floatAccount,
            requiresAuth: true,
          },
        },
        {
          path: "accountWithFloatAccountGroupReport",
          name: "PACNTAccountWithFloatAccountGroupReport",
          component: () =>
            import(
              "@/views/modules/pacnt/reports/accountWithFloatAccountGroupReport"
            ),
          meta: {
            label: label.page.accountWithFloatAccountGroupReport,
            requiresAuth: true,
          },
        },
        {
          path: "floatAccountWithAccount",
          name: "PACNTFloatAccountWithAccount",
          component: () =>
            import(
              "@/views/modules/pacnt/reports/floatAccountWithAccount/levelOne"
            ),
          meta: {
            label: label.menu.floatAccount + "-" + label.menu.account,
            requiresAuth: true,
          },
        },

        {
          path: "personWithFloatAccount",
          name: "PACNTPersonWithFloatAccount",
          component: () =>
            import(
              "@/views/modules/pacnt/reports/personWithFloatAccount/levelOne"
            ),
          meta: {
            label: label.menu.person1 + "-" + label.menu.floatAccount,
            requiresAuth: true,
          },
        },
        {
          path: "floatAccountWithPerson",
          name: "PACNTFloatAccountWithPerson",
          component: () =>
            import(
              "@/views/modules/pacnt/reports/floatAccountWithPerson/levelOne"
            ),
          meta: {
            label: label.menu.floatAccountWithPerson,
            requiresAuth: true,
          },
        },
        {
          path: "trialBalanceReport",
          name: "PACNTTrialBalanceReport",
          component: () =>
            import(
              "@/views/modules/pacnt/reports/trialBalanceReport/index.vue"
            ),
          meta: {
            label: label.page.trialBalanceReport,
            requiresAuth: true,
          },
        },
        {
          path: "profitAndLoss",
          name: "PACNTProfitAndLossReport",
          component: () =>
            import(
              "@/views/modules/pacnt/reports/worksheetReports/ProfitAndLoss.vue"
            ),
          meta: {
            label: label.page.profitAndLossReport,
            requiresAuth: true,
          },
        },
        {
          path: "financialRatio",
          name: "PACNTFinancialRatioReport",
          component: () =>
            import("@/views/modules/pacnt/reports/financialRatioReport"),
          meta: {
            label: label.page.financialRatioReport,
            requiresAuth: true,
          },
        },
        {
          path: "personWithAccount",
          name: "PACNTPersonWithAccount",
          component: () =>
            import("@/views/modules/pacnt/reports/personWithAccount/index.vue"),
          meta: {
            label: label.page.personWithAccount,
            requiresAuth: true,
          },
        },
        {
          path: "personCreditsReport",
          name: "PACNTPersonCreditsReport",
          component: () =>
            import(
              "@/views/modules/pacnt/reports/personCreditsReport/index.vue"
            ),
          meta: {
            label: label.page.personCreditsReport,
            requiresAuth: true,
          },
        },
        {
          path: "personalAccountBalanceReport",
          name: "PACNTPersonalAccountBalanceReport",
          component: () =>
            import(
              "@/views/modules/pacnt/reports/personalAccountBalanceReport/index.vue"
            ),
          meta: {
            label: label.page.personalAccountBalanceReport,
            requiresAuth: true,
          },
        },
        {
          path: "electronicLedgerReport",
          name: "PACNTElectronicLedgerReport",
          component: () =>
            import("@/views/modules/pacnt/reports/electronicLedger"),
          meta: {
            label: label.menu.electronicLedgerReport,
            requiresAuth: true,
          },
        },
        {
          path: "personalFinalVoucherReport",
          name: "PACNTPersonFinalVoucherReport",
          component: () =>
            import(
              "@/views/modules/pacnt/reports/personalFinalVoucherReport/index.vue"
            ),
          meta: {
            label: label.page.personalFinalVoucherReport,
            requiresAuth: true,
          },
        },
        {
          path: "personOfficeReport",
          name: "PACNTPersonOfficeReport",
          component: () =>
            import(
              "@/views/modules/pacnt/reports/personOfficeReport/index.vue"
            ),
          meta: {
            label: label.page.personOfficeReport,
            requiresAuth: true,
          },
        },
        {
          path: "personMultiLevelLedgerReport",
          name: "PACNTPersonMultiLevelLedgerReport",
          component: () =>
            import(
              "@/views/modules/pacnt/reports/personMultiLevelLedgerReport/index.vue"
            ),
          meta: {
            label: label.page.personMultiLevelLedgerReport,
            requiresAuth: true,
          },
        },
        {
          path: "floatAccountBalance",
          name: "PACNTFloatAccountBalance",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "levelOne",
              name: "PACNTFloatAccountBalanceLevelOne",
              component: () =>
                import(
                  "@/views/modules/pacnt/reports/floatAccountBalance/levelOne"
                ),
              meta: {
                label:
                  label.menu.trialBalance + " " + label.menu.floatAccountOne,
                requiresAuth: true,
              },
            },
            {
              path: "levelTwo",
              name: "PACNTFloatAccountBalanceLevelTwo",
              component: () =>
                import(
                  "@/views/modules/pacnt/reports/floatAccountBalance/levelTwo"
                ),
              meta: {
                label:
                  label.menu.trialBalance + " " + label.menu.floatAccountTwo,
                requiresAuth: true,
              },
            },
            {
              path: "levelThree",
              name: "PACNTFloatAccountBalanceLevelThree",
              component: () =>
                import(
                  "@/views/modules/pacnt/reports/floatAccountBalance/levelThree"
                ),
              meta: {
                label:
                  label.menu.trialBalance + " " + label.menu.floatAccountThree,
                requiresAuth: true,
              },
            },
            {
              path: "levelFour",
              name: "PACNTFloatAccountBalanceLevelFour",
              component: () =>
                import(
                  "@/views/modules/pacnt/reports/floatAccountBalance/levelFour"
                ),
              meta: {
                label:
                  label.menu.trialBalance + " " + label.menu.floatAccountFour,
                requiresAuth: true,
              },
            },
            {
              path: "levelFive",
              name: "PACNTFloatAccountBalanceLevelFive",
              component: () =>
                import(
                  "@/views/modules/pacnt/reports/floatAccountBalance/levelFive"
                ),
              meta: {
                label:
                  label.menu.trialBalance + " " + label.menu.floatAccountFive,
                requiresAuth: true,
              },
            },
            {
              path: "text",
              name: "PACNTFloatAccountTextBalance",
              component: () =>
                import(
                  "@/views/modules/pacnt/reports/floatAccountBalance/text"
                ),
              meta: {
                label:
                  label.menu.trialBalance + " " + label.menu.floatAccountText,
                requiresAuth: true,
              },
            },
          ],
        },
        {
          path: "floatAccountOffice",
          name: "PACNTFloatAccountOffice",
          component: () =>
            import("@/views/modules/pacnt/reports/floatAccountOffice"),
          meta: {
            label: label.menu.floatAccountOffice,
            requiresAuth: true,
          },
        },
        {
          path: "voucherNotes",
          name: "PACNTVoucherNotesReport",
          component: () => import("@/views/modules/pacnt/reports/voucherNotes"),
          meta: {
            label: label.page.voucherNotesReport,
            requiresAuth: true,
          },
        },
      ],
    },
  ],
};

const floatAccountOperationDetailLevels = [
  {
    name: "PACNTFloatAccountOperationDetailLevelOne",
    defaultTitle: label.menu.floatAccountOne,
  },
  {
    name: "PACNTFloatAccountOperationDetailLevelTwo",
    defaultTitle: label.menu.floatAccountTwo,
  },
  {
    name: "PACNTFloatAccountOperationDetailLevelThree",
    defaultTitle: label.menu.floatAccountThree,
  },
  {
    name: "PACNTFloatAccountOperationDetailLevelFour",
    defaultTitle: label.menu.floatAccountFour,
  },
  {
    name: "PACNTFloatAccountOperationDetailLevelFive",
    defaultTitle: label.menu.floatAccountFive,
  },
];
export function setPACNTFloatAccountOperationDetailLabels(floatAccount = []) {
  const reports = routeItems.children.find(
    (item) => item.name === "PACNTReports",
  );
  if (!reports) return;

  const operationDetail = reports.children.find(
    (item) => item.name === "PACNTFloatAccountOperationDetail",
  );
  if (!operationDetail) return;

  floatAccountOperationDetailLevels.forEach((level, index) => {
    const route = operationDetail.children.find(
      (item) => item.name === level.name,
    );
    if (!route) return;

    route.meta.label =
      label.menu.operationDetail +
      " " +
      (floatAccount[index]?.title || level.defaultTitle);
  });
}

const floatAccountBalanceLevels = [
  {
    name: "PACNTFloatAccountBalanceLevelOne",
    defaultTitle: label.menu.floatAccountOne,
  },
  {
    name: "PACNTFloatAccountBalanceLevelTwo",
    defaultTitle: label.menu.floatAccountTwo,
  },
  {
    name: "PACNTFloatAccountBalanceLevelThree",
    defaultTitle: label.menu.floatAccountThree,
  },
  {
    name: "PACNTFloatAccountBalanceLevelFour",
    defaultTitle: label.menu.floatAccountFour,
  },
  {
    name: "PACNTFloatAccountBalanceLevelFive",
    defaultTitle: label.menu.floatAccountFive,
  },
];
export function setPACNTFloatAccountBalanceLabels(floatAccount = []) {
  const reports = routeItems.children.find(
    (item) => item.name === "PACNTReports",
  );
  if (!reports) return;

  const balance = reports.children.find(
    (item) => item.name === "PACNTFloatAccountBalance",
  );
  if (!balance) return;

  floatAccountBalanceLevels.forEach((level, index) => {
    const route = balance.children.find((item) => item.name === level.name);
    if (!route) return;

    route.meta.label =
      label.menu.trialBalance +
      " " +
      (floatAccount[index]?.title || level.defaultTitle);
  });
}

export default routeItems;
